import { Fragment, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, ToolTip } from "../../../AbstractElements";
import { DisabledTooltipTitle } from "../../../Constants/Constants";
import { DisabledTooltipSubTitle } from "../../../Data/UiKits/Tooltip";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const DisabledTooltip = () => {
  const [openIndex, setOpenIndex] = useState(false);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={DisabledTooltipTitle} span={DisabledTooltipSubTitle} />
        <CardBody className="fill-tooltip">
          <div className="common-flex">
            <Fragment>
              <Btn color="primary" id={`filled_DisabledButton`} onClick={() => setOpenIndex(true)} disabled>"Disabled button"</Btn>
              <ToolTip isOpen={openIndex} target={`filled_DisabledButton`} toggle={() => setOpenIndex(false)}>"Disabled button"</ToolTip>
            </Fragment>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DisabledTooltip;
